<template>
<div>
	<a-select
		mode="multiple" 
		style="min-width: 260px;max-width: 600px;"
		placeholder="请选择广告计划"
		:filter-option="false"
		@change="handleChangeE"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScroll_Plan" 
		showSearch
		allowClear
		@search="select_Plan_Search"
		:not-found-content="plan_fetching ? undefined : null" 
		@blur="planBlur"
	  >
		<a-spin v-if="plan_fetching" slot="notFoundContent" size="small" />
		<a-select-option v-for="(item,index) in plan_Select" :key="item.campaign_id" :value="item.campaign_id" :title="item.campaign_name">
		  {{item.campaign_name}}
		</a-select-option>
		<a-select-option v-if="plan_loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
</div>
</template>

<script>
import { KSPlanSelect } from '@/request/api'
export default {
	name: 'planSelect',
	props: ['page_type'],
	data(){
		return {
			// 广告计划
			plan_Select: [], // 选择广告计划
			plan_Blur: [], // 保存一份，用于失去焦点后，回复原来的数值
			plan_page: 1,
			p_plan_name: "", // 下拉选择框的搜索字段
			plan_fetching: false, // 用于控制提示
			plan_loading_more_control: true, // 上拉加载更多控制
			plan_loading_more_hint: false, // 上拉加载更多的提示
			r_plan_id: [], // 广告计划
			// 广告计划结束
		}
	},
	mounted(){
		let that = this
		
		// 广告计划
		KSPlanSelect({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			// console.log("广告计划",res);
			that.plan_Select = res.data.data.data
			that.plan_Blur = res.data.data.data
		})
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 广告计划部分开始
		handleChangeE(e){
			// console.log(e);
			this.r_plan_id = e
			this.$emit('handle-change',e)
		},
		popupScroll_Plan(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.plan_loading_more_control){ // 节流，保证这期间只执行一次
					this.plan_loading_more_hint = true
					this.plan_loading_more_control = false
					let that = this
					that.plan_page = that.plan_page + 1
					// console.log("上拉触底加载更多");
					KSPlanSelect({
						page: that.plan_page,
						limit: that.s_limit,
						plan_name: that.p_plan_name,
					}).then(res=>{
						// console.log('选择',res);
						
						let data = that.plan_Select 
						that.plan_loading_more_hint = false
						that.plan_Select = data.concat(res.data.data.data) 
						that.plan_fetching = false
						
						if(that.plan_Select.length < res.data.data.total){
							that.plan_loading_more_control = true
						}
					})
				}
			}
		},
		// 选择框搜索-选择广告计划
		select_Plan_Search(e){
			// console.log("选择框搜索",e);
			let that = this
			that.plan_Select = []
			that.plan_fetching = true
			that.p_plan_name = e
			
			KSPlanSelect({
				page: 1,
				limit: that.s_limit,
				plan_name: e,
			}).then(res=>{
				// console.log('选择',res);
				that.plan_page = 1
				that.plan_Select = res.data.data.data
				that.plan_fetching = false
				
				if(that.plan_Select.length < res.data.data.total){
					that.plan_loading_more_control = true
				}
				else {
					that.plan_loading_more_control = false
				}
			})
		},
		// 失去焦点
		planBlur(e){
			let that = this
			// console.log("失去焦点",e);
			that.plan_page = 1
			that.p_plan_name = '' // 清空
			that.plan_Select = that.plan_Blur 
			
			that.plan_loading_more_control = true
		},
		// 广告计划部分结束
	}
}
</script>

<style>
</style>